import { useEffect, useRef, useState } from 'react';
import DocumentPortal from 'react-document-portal';
import useKeypress from 'react-use-keypress';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

var useLockBodyScroll = function useLockBodyScroll() {
  useEffect(function () {
    var overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflow = overflow;
    };
  }, []);
};

var useMessage = function useMessage(handler) {
  var handlerRef = useRef();
  handlerRef.current = handler;
  useEffect(function () {
    var listener = function listener(event) {
      return handlerRef.current(event);
    };
    window.addEventListener('message', listener);
    return function () {
      window.removeEventListener('message', listener);
    };
  }, []);
};

var Modal = function Modal(_ref) {
  var onRequestClose = _ref.onRequestClose;
  useLockBodyScroll();
  useKeypress('Escape', onRequestClose);
  useMessage(function (event) {
    if ('closeModal' === event.data) {
      onRequestClose();
    }
  });
  return /*#__PURE__*/jsx(DocumentPortal, {
    children: /*#__PURE__*/jsx("div", {
      "aria-modal": "true",
      role: "dialog",
      style: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        overflow: 'auto'
      },
      children: /*#__PURE__*/jsx("iframe", {
        "aria-label": "The Shielded Site",
        frameBorder: "0",
        height: "455",
        onLoad: function onLoad(event) {
          var _event$target;
          (_event$target = event.target) == null ? void 0 : _event$target.focus();
        },
        sandbox: "allow-forms allow-scripts allow-same-origin allow-popups",
        src: "https://staticcdn.co.nz",
        style: {
          maxHeight: '100%',
          opacity: 0.98
        },
        width: "310"
      })
    })
  });
};

var SvgButton = function SvgButton() {
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 192 192",
    children: [/*#__PURE__*/jsx("circle", {
      cx: 96,
      cy: 96,
      r: 96,
      fill: "#445e5c"
    }), /*#__PURE__*/jsx("circle", {
      cx: 96,
      cy: 95,
      r: 87,
      fill: "#fff"
    }), /*#__PURE__*/jsx("path", {
      fill: "#445e5c",
      d: "M96 11a84 84 0 0 0 0 168z"
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 3,
      children: [/*#__PURE__*/jsx("path", {
        strokeDasharray: 6,
        d: "M96 50.5H48a2.5 2.5 0 0 0-2.5 2.5v70a2.5 2.5 0 0 0 2.5 2.5h48"
      }), /*#__PURE__*/jsx("path", {
        strokeDasharray: "7 6",
        d: "M99.76 135.5h-43a2 2 0 0 0-1.76 1.11l-4 8a2 2 0 0 0 .08 1.94c.37.6 1 .95 3.71.95h44.79"
      })]
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      stroke: "#445e5c",
      children: [/*#__PURE__*/jsx("path", {
        strokeWidth: 6,
        d: "M96 52h47a1 1 0 0 1 1 1v70a1 1 0 0 1-1 1H96"
      }), /*#__PURE__*/jsx("path", {
        strokeWidth: 3,
        d: "M96 135.5h39a2 2 0 0 1 1.79 1.11l4 8a2 2 0 0 1-1.79 2.89H96"
      }), /*#__PURE__*/jsx("path", {
        strokeWidth: 2,
        d: "M96 141h43m-37-5v5m8.5-5 .5 5m8-5 1 5m7-5 4 11"
      })]
    })]
  });
};

var Shielded = function Shielded() {
  var buttonRef = useRef(null);
  var _useState = useState(false),
    isOpen = _useState[0],
    setOpen = _useState[1];
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("button", {
      "aria-label": "Women\u2019s Refuge",
      onClick: function onClick() {
        setOpen(true);
      },
      ref: buttonRef,
      style: {
        display: 'inline-block',
        margin: 0,
        padding: 0,
        border: 'none',
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        appearance: 'none',
        background: 'none',
        cursor: 'pointer',
        opacity: isOpen ? 0 : 1
      },
      type: "button",
      children: /*#__PURE__*/jsx(SvgButton, {})
    }), isOpen && /*#__PURE__*/jsx(Modal, {
      onRequestClose: function onRequestClose() {
        var _buttonRef$current;
        setOpen(false);
        (_buttonRef$current = buttonRef.current) == null ? void 0 : _buttonRef$current.focus();
      }
    })]
  });
};

export { Shielded as default };
